import axios from 'axios';
import _ from 'lodash';

axios.defaults.baseURL = process.env.REACT_APP_API_SERVER;

axios.interceptors.request.use(
  config => {

    const user = JSON.parse(localStorage.getItem('user'));

    const token = _.get(user, 'token', null);

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  err => {
    Promise.reject(err);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (err.response?.status === 401 || err.response?.status === 403) {

      localStorage.clear();

      window.location.replace('/');

      return Promise.reject(err);
    }

    return Promise.reject(err);
  }
);

export default axios;
